var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.9999 36.6673C29.2047 36.6673 36.6666 29.2054 36.6666 20.0007C36.6666 10.7959 29.2047 3.33398 19.9999 3.33398C10.7952 3.33398 3.33325 10.7959 3.33325 20.0007C3.33325 29.2054 10.7952 36.6673 19.9999 36.6673Z",
    fill: "#FB4764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.9173C20.6833 22.9173 21.25 22.3507 21.25 21.6673V13.334C21.25 12.6507 20.6833 12.084 20 12.084C19.3167 12.084 18.75 12.6507 18.75 13.334V21.6673C18.75 22.3507 19.3167 22.9173 20 22.9173Z",
    fill: "#FB4764"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5333 26.0328C21.4499 25.8328 21.3333 25.6495 21.1833 25.4828C21.0166 25.3328 20.8333 25.2161 20.6333 25.1328C20.2333 24.9661 19.7666 24.9661 19.3666 25.1328C19.1666 25.2161 18.9833 25.3328 18.8166 25.4828C18.6666 25.6495 18.5499 25.8328 18.4666 26.0328C18.3833 26.2328 18.3333 26.4495 18.3333 26.6661C18.3333 26.8828 18.3833 27.0995 18.4666 27.2995C18.5499 27.5161 18.6666 27.6828 18.8166 27.8495C18.9833 27.9995 19.1666 28.1161 19.3666 28.1995C19.5666 28.2828 19.7833 28.3328 19.9999 28.3328C20.2166 28.3328 20.4333 28.2828 20.6333 28.1995C20.8333 28.1161 21.0166 27.9995 21.1833 27.8495C21.3333 27.6828 21.4499 27.5161 21.5333 27.2995C21.6166 27.0995 21.6666 26.8828 21.6666 26.6661C21.6666 26.4495 21.6166 26.2328 21.5333 26.0328Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFail);
export default __webpack_public_path__ + "static/media/IcFail.3f0c8825f18e5f5fce2ab6cb358856d7.svg";
export { ForwardRef as ReactComponent };